import { VariationType } from "../../../contexts/ProductsContext";
import { ImageType, VariationImageType } from "../productTypes";
import { buildImageUrl, isImageAlreadyAdded } from "./helper";

function buildImages(images: ImageType[]) {
    const variationFromImages: VariationImageType[] = [];
    let imgGuide: string | null = null;
    images
        .sort(
            (a: ImageType, b: ImageType) =>
                b.typeimg.length - a.typeimg.length,
        )
        .forEach((image: ImageType) => {
            const { typeimg, path, imgsuffix } = image;

            if (typeimg === "image" || typeimg === "mainpicture") {
                const imgProduct = buildImageUrl(path, imgsuffix);

                if (
                    imgProduct &&
                    !isImageAlreadyAdded(variationFromImages, imgProduct)
                ) {
                    variationFromImages.push({
                        sku: "",
                        image: imgProduct,
                        order: image.order,
                    });
                }
            }

            if (typeimg === "guide") {
                 imgGuide = buildImageUrl(path, imgsuffix);
            }
        });

        return {
            variationFromImages,
            imgGuide,
        }
}

function buildVariation() {

}

function build() {

}

function getPricesAndVariations(variations: VariationType[]): {
    minimumPrice: number;
    minimunPrice: number;
    grandPrice: number;
    maximumPrice: number;
    minimumVariation: VariationType | null;
    maximumVariation: VariationType | null,
    pricePreview: number
    promotionalPricePreview: number
} {
    try {
        let minimumPrice = Number.MAX_VALUE;
        let maximumPrice = Number.MIN_VALUE;
        let minimumVariation: VariationType | null = null;
        let maximumVariation: VariationType | null = null;
        variations.forEach((vrt: VariationType) => {
            if (vrt.price < minimumPrice) {
                minimumPrice = vrt.price;
                minimumVariation = vrt;
            }
            if (vrt.price > maximumPrice) {
                maximumPrice = vrt.price;
                maximumVariation = vrt;
            }
        });

        const pricePreview = (minimumVariation && (minimumVariation as any).price) ? (minimumVariation as any).price : variations[0].price;
        const grandPrice = (maximumVariation && (maximumVariation as any).price) ? (maximumVariation as any).price : variations[0].price;
        const minimunPrice = (minimumVariation && (minimumVariation as any).price) ? (minimumVariation as any).price : variations[0].price;
        const promotionalPricePreview = (maximumVariation && (maximumVariation as any).promotionalPrice) ? (maximumVariation as any).promotionalPrice : variations[0].promotionalPrice;


        return {
            minimumPrice,
            maximumPrice,
            minimumVariation,
            maximumVariation,
            pricePreview,
            grandPrice,
            minimunPrice,
            promotionalPricePreview
        };

    } catch (error) {
        console.log("Erro ao buscar variações:", error);

        return {
            minimumPrice: 0,
            maximumPrice: 0,
            minimumVariation: null,
            maximumVariation: null,
            pricePreview: 0,
            grandPrice: 0,
            promotionalPricePreview: 0,
            minimunPrice: 0
        }
    }
}

export { buildImages, buildVariation, build, getPricesAndVariations };